<template>
  <div :class="{ container: !isMobile, 'pb-70': isMobile }">
    <section v-if="isMobile" class="top-section" style="padding-bottom: 20px">
      <el-button style="width: 100% !important" @click="goToList">
        К Списку водителей
      </el-button>
    </section>
    <breadcrumb v-if="!isMobile" crumb="driver-add" />
    <el-form ref="formAddDriver" :model="driver">
      <el-row :gutter="!isMobile ? 24 : 0">
        <el-col :span="isMobile ? 24 : 18">
          <div class="my_container-card">
            <el-card class="box-card driver_add_card">
              <div v-if="!isMobile" slot="header" class="clearfix">
                <span class="my_container-card-title">
                  Добавление водителя
                </span>
              </div>
              <section v-if="isMobile">
                <el-alert
                  v-show="notes"
                  :title="notes"
                  type="error"
                  show-icon
                />
                <h3 v-if="isMobile" style="color: #409eff">
                  Форма добавления водителя
                </h3>
                <el-row>
                  <el-col :span="24">
                    <p><b>ФИО:</b></p>
                    <el-input
                      v-model="driver.fio"
                      placeholder="Введите Ваше ФИО"
                      @input="toCapital"
                    />
                    <p style="color: grey; font-size: 12px">
                      Номер паспорт или водительское обязательно
                    </p>
                    <p><b>Номер паспорта</b></p>
                    <el-input
                      v-model="driver.passport"
                      placeholder="Укажите номер паспорта (без пробелов)"
                      min="10"
                      max="10"
                      @input="driver.passport = clearSpace(driver.passport)"
                    />
                    <p><b>Водительское удостоверение</b></p>
                    <el-input
                      v-model="driver.driver_licence"
                      placeholder="Введите номер водительского удостоверения"
                      @input="
                        driver.driver_licence = clearSpace(
                          driver.driver_licence,
                        )
                      "
                    />
                    <p style="color: grey; font-size: 12px">
                      Номер паспорт или водительское обязательно
                    </p>
                    <el-button
                      v-if="edit_form"
                      type="success"
                      @click="postDriver"
                    >
                      Добавить водителя
                    </el-button>
                  </el-col>
                </el-row>
                <el-collapse-transition>
                  <div v-if="detected_password">
                    <el-row>
                      <el-col :span="24">
                        <p>Номер телефона</p>
                        <el-form-item
                          prop="phone"
                          :rules="{
                            required: true,
                            message: 'Введите номер телефона водителя',
                            trigger: 'blur',
                          }"
                        >
                          <el-input
                            v-model="driver.phone"
                            v-mask="'+7 (###) ###-##-##'"
                            placeholder="Введите номер телефона"
                          />
                        </el-form-item>
                        <p>Удостоверение личности</p>
                        <upload-document-modal
                          ref="uploadDocumentModal"
                          name-document="Паспорт водителя"
                          :data-edit="documents.driver"
                          :source-id="documents.driver.sourceId"
                          :need-additional="false"
                        />
                      </el-col>
                    </el-row>
                    <set-carrier
                      v-if="canAction('action_set_reason')"
                      :driver="driver"
                      @changed="setCarrier"
                    />
                  </div>
                </el-collapse-transition>
              </section>
              <section v-if="!isMobile" class="my_container">
                <el-alert
                  v-show="notes"
                  :title="notes"
                  type="error"
                  show-icon
                />
                <el-row :gutter="24">
                  <el-col :span="12">
                    <p>ФИО*</p>
                    <el-input
                      v-model="driver.fio"
                      placeholder="Введите Ваше ФИО"
                      @input="toCapital"
                    />
                  </el-col>
                  <el-col :span="12">
                    <p>Номер паспорта</p>
                    <el-input
                      v-model="driver.passport"
                      placeholder="Укажите номер паспорта (без пробелов)"
                      min="10"
                      max="10"
                      @input="driver.passport = clearSpace(driver.passport)"
                    />
                  </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="12">
                    <p>Водительское удостоверение</p>
                    <el-input
                      v-model="driver.driver_licence"
                      placeholder="Введите номер водительского удостоверения"
                      @input="
                        driver.driver_licence = clearSpace(
                          driver.driver_licence,
                        )
                      "
                    />
                  </el-col>
                  <el-col :span="12">
                    <p class="empty-p" />
                    <el-button v-if="edit_form" plain @click="postDriver">
                      Добавить водителя
                    </el-button>
                  </el-col>
                </el-row>
                <el-collapse-transition>
                  <div v-if="detected_password">
                    <el-row :gutter="24">
                      <el-col :span="12">
                        <p>Номер телефона</p>
                        <el-input
                          v-model="driver.phone"
                          v-mask="'+7 (###) ###-##-##'"
                          placeholder="Введите номер телефона"
                        />
                      </el-col>
                      <el-col :span="12">
                        <p>Удостоверение личности</p>
                        <upload-document-modal
                          ref="uploadDocumentModal"
                          name-document="Паспорт водителя"
                          :data-edit="documents.driver"
                          :source-id="documents.driver.sourceId"
                          :need-additional="false"
                        />
                      </el-col>
                    </el-row>
                    <set-carrier
                      v-if="canAction('action_set_reason')"
                      :driver="driver"
                      @changed="setCarrier"
                    />
                  </div>
                </el-collapse-transition>
              </section>
              <div
                v-if="detected_password && !isMobile"
                class="driver-buttons-block"
              >
                <el-button
                  v-if="!edit_form && !isMobile"
                  style="margin: 20px"
                  @click="cleanForm"
                >
                  Отмена
                </el-button>
                <el-button
                  v-if="!isMobile"
                  style="margin: 20px"
                  type="primary"
                  @click="updateDriver"
                >
                  Сохранить
                </el-button>
              </div>
              <div v-if="isMobile && detected_password">
                <el-button
                  v-if="isMobile"
                  style="margin-top: 20px"
                  type="success"
                  @click="updateDriver"
                >
                  Сохранить
                </el-button>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <driver-edit
      :edit-driver="editDriver"
      :close-modal="goToList"
      :dialog-visible="dialogVisible"
    />
  </div>
</template>

<script>
import { GET_PROFILE } from '@/store/actions/userprofile'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { capital_letter } from '@/helpers/functions'
import { filesValidateMixinChildActions } from '@/mixins/filesValidateMixin'
import { hints } from '@/datas/consts'
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb'
import DriverEdit from './Driver-edit'
import SetCarrier from '@/views/Driver/Forms/SetСarrier'
import UploadDocumentModal from '../../components/Upload/UploadDocumentModal'

const Driver = RepositoryFactory.get('driver')

export default {
  name: 'DriverAdd',
  components: {
    UploadDocumentModal,
    SetCarrier,
    DriverEdit,
    Breadcrumb,
  },
  mixins: [filesValidateMixinChildActions],
  data() {
    return {
      edit_form: true,
      detected_password: false,
      driver: {
        fio: '',
        driver_licence: '',
        passport: '',
        phone: '',
        carrier_inn: '',
        carrier_name: '',
        user_org_inn: '',
      },
      documents: {
        driver: {
          sourceModelName: 'drivers',
          sourceId: 0,
          documentType: 'passport',
        },
      },
      helper: [],
      defaultHelpTitle: hints.default,
      source_id: 0,
      notes: '',
      dialogVisible: false,
      editDriver: {},
      filesValidateMixinData: {
        refComponentName: 'uploadDocumentModal',
        errorMessage: 'удостоверение личности',
        childFilesCountProperty: 'countFiles',
      },
    }
  },
  mounted() {
    const { inn, short_name } = this.userInfo.current.organization

    this.driver.fio =
      short_name && !this.userInfo.profile.has_drivers
        ? this.isIP(short_name)
        : ''
    this.driver.phone = !this.userInfo.profile.has_drivers
      ? this.userInfo.phone
      : ''
    this.driver.carrier_inn = inn
    this.driver.carrier_name = short_name
    this.driver.user_org_inn = inn
  },
  methods: {
    isIP(short_name) {
      return short_name.includes('ИП ', 0) ? short_name.substr(3) : ''
    },
    toCapital(val) {
      this.driver.fio = capital_letter(val)
    },
    cleanForm() {
      this.driver.passport = ''
      this.driver.fio = ''
      this.driver.phone = ''
      this.driver.driver_licence = ''
      this.driver.carrier_inn = ''
      this.driver.carrier_name = ''
      this.edit_form = true
      this.detected_password = false
      this.source_id = 0
    },
    checkErrors() {
      if (!this.driver.fio) {
        this.notes = 'ФИО обязательно для заполнения'
      } else if (!this.driver.passport && !this.driver.driver_licence) {
        this.notes =
          'Необходимо заполнить данные паспорта или водительского удостоверения'
      } else if (
        this.driver.passport.length !== 10 &&
        this.driver.passport.length !== 0
      ) {
        this.notes = 'Значение «Passport» должно содержать 10 символов'
      } else if (!this.driver.carrier_inn && Number(this.source_id) !== 0) {
        this.notes = 'Необходимо выбрать перевозчика'
      } else {
        this.notes = ''
      }
    },
    postDriver() {
      this.checkErrors()

      if (!this.notes) {
        Driver.postDriver({
          fio: this.driver.fio,
          driver_licence: this.driver.driver_licence,
          passport: this.driver.passport,
          user_org_inn: this.driver.user_org_inn,
          phone: this.driver.phone,
          carrier_name: this.driver.carrier_name,
          carrier_inn: this.driver.carrier_inn,
        })
          .then(res => {
            if (res.status === 200) {
              this.edit_form = false
              this.documents.driver.sourceId = res.data.driver.id
              this.source_id = res.data.driver.id
              this.detected_password = true

              if (this.isDriverRole) {
                this.$alert(
                  'Водитель добавлен успешно. Добавьте документы к водителя',
                )
              }
            }
          })
          .catch(err => {
            if (err.status === 400 && err.data.errors.passport) {
              this.$confirm(
                'Водитель с таким удостоверением уже существует.\n' +
                  'Перейти к редактированию его данных?',
                '',
                {
                  confirmButtonText: 'Да',
                  cancelButtonText: 'Нет',
                  type: 'warning',
                },
              )
                .then(() => this.goToEditDriver())
                .catch(() => {})
            }
          })
      }
    },
    goToEditDriver() {
      Driver.getDriver().then(res => {
        this.editDriver = res.data.items.find(
          obj => obj.passport === this.driver.passport,
        )
        this.dialogVisible = true
      })
    },
    goToList() {
      const path =
        this.$route.name === 'DriverAddMobile'
          ? '/drivers-mobile'
          : '/driver/list'

      this.$router.push({ path })
    },
    updateDriver() {
      this.checkErrors()

      // if (!this.notes && this.checkCountFilesBeforeSaveInOwn()) {
      if (!this.notes) {
        this.$refs['formAddDriver'].validate(valid => {
          if (valid) {
            Driver.updateDriver(this.source_id, this.driver)
              .then(res => {
                if (res.status === 200) {
                  if (this.isDriverRole && !this.userInfo.has_drivers) {
                    this.$store.dispatch(`userProfile/${GET_PROFILE}`)
                    this.$alert('Водитель добавлен успешно', 'Успешно')
                  }
                  this.goToList()
                }
              })
              .catch(err => {
                if (err.status === 400 && err.data.errors.passport) {
                  this.notes = `Значение «Passport» - ${this.driver.passport} уже существует`
                }
              })
          }
        })
      }
    },
    setCarrier(data) {
      this.driver.carrier_inn = data.carrier_inn
      this.driver.carrier_name = data.carrier_name
    },
  },
}
</script>

<style lang="sass" scoped>
.driver_add_card
  .compact-field
    display: flex
  .empty-p
    height: 18px
  .driver-buttons-block
     display: flex
     justify-content: flex-end
</style>
